module.exports = __webpack_public_path__ + "img/arag_Kinderfreibetrag.45194d28.svg";